<template>
  <div class="box">
    <div class="box-body">
      <el-row class="margin-bottom-10" gutter="20">
        <el-col :span="18">
          <el-button type="primary" size="small" @click="toAdd()" plain><i class="fa fa-plus"></i> 添加岗位</el-button>
        </el-col>
      </el-row>
      <el-table class="list-table" :data="postList" border :stripe="true" style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{scope.$index + page.pageSize * (page.pageNo - 1) + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="岗位名称" prop="name"></el-table-column>
        <el-table-column label="类别" prop="type">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type==1">通用岗位</el-tag>
            <el-tag v-if="scope.row.type==2">公司岗位</el-tag>
          </template>

        </el-table-column>
        <el-table-column label="所属客户" prop="customerName"></el-table-column>
        <el-table-column prop="modelNum" label="模型数量" width="400">
          <template slot-scope="scope">
            {{scope.row.modelNum}}个
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="text" @click="toAdd(scope.row.id)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click="toDelete(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <page-bar v-model="page" @change="fetchData"></page-bar>

      <post-save :visible="addDialog" :post-id="postId" @done="handleFinish"></post-save>
    </div>
  </div>
</template>

<script>
import {fetchList, remove} from '@/api/rep/post'
import {mapGetters} from "vuex";
import PageBar from '@/components/PageBar.vue'
import postSave from "./PostSave";
import {handleConfirm} from "@/utils/confirm";

export default {
  name: 'post-list',
  components: {postSave, PageBar},
  computed: {
    ...mapGetters(['user', 'company'])
  },
  created() {
    this.fetchData()
  },
  data: function () {
    return {
      postList: [],
      post: {},
      addDialog: false,
      page: {
        pageSize: 20,
        pageNo: 1
      },
    }
  },
  methods: {
    fetchData() {
      let {pageNo, pageSize} = this.page
      fetchList({pageNo, pageSize,param:{type:2}}).then(res => {
        this.page = res.data.result
        this.postList = res.data.result.records
      })
    },
    toAdd(val) {
      this.postId = val
      this.addDialog = true
    },
    toDelete(id) {
      handleConfirm('此操作将删除该维度, 是否继续?').then(() => {
        remove(id).then(resp => {
          this.$message.success(resp.data.message);
          this.fetchData();
        })
      })
    },
    handleFinish(flag = false) {
      this.addDialog = false
      if (flag) {
        this.fetchData()
      }
    }
  },
}
</script>
